import Rollbar from 'rollbar'
import { rollbarConfig } from './constants'

export const rollbar = new Rollbar(rollbarConfig)
